import { format } from 'date-fns';

import { Locales } from '../../config/constants';

export const localeToDatePlaceholder: Record<Locales, string> = {
    [Locales.en]: 'mm/dd/yyyy',
    [Locales.fr]: 'jj/mm/aaaa',
};

export const localeToDateFormat: Record<Locales, string> = {
    [Locales.en]: 'MM/dd/yyyy',
    [Locales.fr]: 'dd/MM/yyyy',
};

export const localeToShortDateFormat: Record<Locales, string> = {
    [Locales.en]: 'MM/dd',
    [Locales.fr]: 'dd/MM',
};

export const convertTimestampToDatetimeString = (timestamp: number | null) => {
    if (!timestamp) return null;
    return format(timestamp, "yyyy-MM-dd'T'HH:mm");
};
